import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from "@chakra-ui/react";
import { safeHTML } from "@lib/html";
import { isEmpty } from "lodash";

const AccordionItemWrapper = ({ question, answer }: any) => (
  <AccordionItem
    borderTop={0}
    borderBottom="1px"
    borderBottomColor="neutral.800"
  >
    <AccordionButton px={0} py={5}>
      <p
        className="font-medium text-base text-neutral-300 flex-1 text-left"
        dangerouslySetInnerHTML={safeHTML(question)}
      ></p>
      <AccordionIcon width="2rem" fontSize="2rem" color="neutral.300" />
    </AccordionButton>

    <AccordionPanel>
      <p
        className="text-base text-neutral-40"
        dangerouslySetInnerHTML={safeHTML(answer)}
      ></p>
    </AccordionPanel>
  </AccordionItem>
);

const EventDetailFAQ = ({
  faqs: faqs = [],
}: {
  faqs?: { question: string; answer: string }[];
}) => {
  if (isEmpty(faqs)) return <></>;
  return (
    <div className="mb-16 w-full">
      <p className="text-2xl mb-4 capitalize dark:text-white">
        Frequently Asked Questions
      </p>
      <Accordion allowMultiple>
        {faqs.map(
          (faqItem: { question: string; answer: string }, index: number) => (
            <AccordionItemWrapper key={index} {...faqItem} />
          )
        )}
      </Accordion>
    </div>
  );
};

export default EventDetailFAQ;
